import { CustomerType } from '@repo/common';
import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

export const SingleCustomerSchema = z.object({
    id: z.string(),
    address: z.string(),
    email: z.string(),
    name: z.string(),
    phone_number: z.string(),
    customer_type: z.nativeEnum(CustomerType),
    created_at: z.string(),
    updated_at: z.string().nullable(),
    serial_id: z.number().optional(),
    status: z.string().optional(),
    total_orders: z.number().optional(),
    average_order_value: z.number().optional(),
    last_order_date: z.string().nullable().optional(),
    total_paid: z.number().optional(),
    total_price: z.number().optional(),
    total_due: z.number().optional(),
    created_by_name: z.string().optional(),
});

export type TCustomerListItem = z.infer<typeof SingleCustomerSchema>;

export const ResponseCustomerListSchema = z.object({
    data: z.array(SingleCustomerSchema),
    message: z.string(),
    pagination: PaginationResponseSchema,
});

export type TCustomerListResponse = z.infer<typeof ResponseCustomerListSchema>;

export const ResponseSingleCustomerSchema = z.object({
    data: SingleCustomerSchema,
});

export type CustomerList = z.infer<typeof ResponseCustomerListSchema>;
export type SingleCustomer = z.infer<typeof ResponseSingleCustomerSchema>;
